/* odaban® Black Deals 2026: Anmeldung (Klaviyo Client API), Countdown, Phase-Umschaltung, Einblenden */
(function () {
  if (window.obwInit) return; window.obwInit = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Countdown bis Early Access; danach Live-Zustand ---------- */
  function countdown(root) {
    var end = root.getAttribute('data-start'); if (!end) return;
    var t = Date.parse(end); if (isNaN(t)) return;
    var box = root.querySelector('.obw-timer');
    var u = box ? { d: box.querySelector('[data-u=d]'), h: box.querySelector('[data-u=h]'), m: box.querySelector('[data-u=m]'), s: box.querySelector('[data-u=s]') } : null;
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var left = t - Date.now();
      if (left <= 0) { root.classList.add('is-live'); return; }
      if (u) {
        var s = Math.floor(left / 1000);
        u.d.textContent = Math.floor(s / 86400); u.h.textContent = pad(Math.floor(s % 86400 / 3600));
        u.m.textContent = pad(Math.floor(s % 3600 / 60)); u.s.textContent = pad(s % 60);
        box.classList.toggle('is-urgent', left < 864e5);
      }
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- Anmeldung ---------- */
  function burst(host) {
    if (reduce) return;
    var b = document.createElement('div'); b.className = 'obw-burst'; host.appendChild(b);
    var cols = ['#00AFAA', '#5FD6D0', '#DDF4F1', '#083F3C'];
    for (var i = 0; i < 28; i++) {
      var p = document.createElement('i'), a = Math.random() * Math.PI * 2, r = 80 + Math.random() * 130;
      p.style.cssText = '--x:' + Math.cos(a) * r + 'px;--y:' + Math.sin(a) * r + 'px;--r:' + (Math.random() * 540) + 'deg;--c:' + cols[i % 4];
      b.appendChild(p);
    }
    setTimeout(function () { b.remove(); }, 1000);
  }
  function param(n) { try { return new URLSearchParams(location.search).get(n) || ''; } catch (e) { return ''; } }
  function signup(form) {
    if (form.dataset.obwReady) return; form.dataset.obwReady = '1';
    var wrap = form.closest('.obw-form'), company = form.getAttribute('data-company'), list = form.getAttribute('data-list');
    var email = form.querySelector('[name=email]'), first = form.querySelector('[name=first_name]'), hp = form.querySelector('[name=website]');
    var err = form.querySelector('.obw-form__err'), btn = form.querySelector('.obw-btn');
    var live = wrap.querySelector('[role=status]');
    var seenKey = 'obw-signup-' + list;
    try { if (localStorage.getItem(seenKey) === '1') { wrap.classList.add('is-done'); } } catch (e) {}
    /* Rückkehr aus der Bestätigungsmail (Double-Opt-in): Ticket gilt jetzt */
    if (param('bestaetigt') === '1') {
      wrap.classList.add('is-done', 'is-confirmed');
      var st = wrap.querySelector('.obw-tk__stamp'); if (st) st.textContent = form.getAttribute('data-confirmed') || 'Bestätigt';
      var tk = wrap.querySelector('.obw-tk'); if (tk) tk.classList.add('is-torn');
      try { localStorage.setItem(seenKey, '1'); localStorage.setItem('obw-tk-torn', '1'); } catch (e) {}
    }
    function fail(msg) { err.textContent = msg; err.classList.add('is-on'); email.setAttribute('aria-invalid', 'true'); email.focus(); }
    function tkno(v) { var h = 5381; for (var i = 0; i < v.length; i++) h = ((h << 5) + h + v.charCodeAt(i)) >>> 0; return 'BD-' + h.toString(36).toUpperCase().slice(-4).padStart(4, '0'); }
    function setNo(n) { var el = wrap.querySelector('[data-obw-tkno]'); if (el && n) el.textContent = n; }
    try { setNo(localStorage.getItem(seenKey + '-no')); } catch (e) {}
    function done() {
      var no = tkno((email.value || '').trim().toLowerCase()); setNo(no);
      try { localStorage.setItem(seenKey + '-no', no); } catch (e) {}
      wrap.classList.add('is-done'); burst(wrap);
      try { localStorage.setItem(seenKey, '1'); } catch (e) {}
      if (live) live.textContent = form.getAttribute('data-live') || '';
      try { if (window.fbq) fbq('track', 'Lead', { content_name: 'Black Deals Early Access' }); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; dataLayer.push({ event: 'black_deals_signup', signup_source: source() }); } catch (e) {}
      try { if (window.ttq) ttq.track('SubmitForm'); } catch (e) {}
      var t = wrap.querySelector('.obw-tk__title'); if (t) t.focus();
    }
    function source() {
      var s = param('utm_source'), m = param('utm_medium');
      if (s) return (s + (m ? '_' + m : '')).toLowerCase();
      return form.getAttribute('data-source') || 'lp';
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (hp && hp.value) return;
      err.classList.remove('is-on'); email.removeAttribute('aria-invalid');
      var v = (email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { fail(form.getAttribute('data-err-mail') || 'Bitte eine gültige E-Mail-Adresse eingeben.'); return; }
      if (!company || !list) { fail(form.getAttribute('data-err') || 'Das hat nicht geklappt. Bitte versuche es gleich noch einmal.'); return; }
      btn.setAttribute('aria-busy', 'true');
      var body = { data: { type: 'subscription', attributes: {
        custom_source: form.getAttribute('data-custom-source') || 'Black Deals LP',
        profile: { data: { type: 'profile', attributes: {
          email: v, first_name: first ? (first.value || '').trim() : undefined,
          properties: { signup_source: source(), black_deals_2026: true, utm_campaign: param('utm_campaign') || undefined, utm_content: param('utm_content') || undefined }
        } } }
      }, relationships: { list: { data: { type: 'list', id: list } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body)
      }).then(function (r) { if (r.status === 202 || r.ok) done(); else throw r; })
        .catch(function () { fail(form.getAttribute('data-err') || 'Das hat nicht geklappt. Bitte versuche es gleich noch einmal.'); })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  }


  /* ---------- Abriss-Ticket: Folie folgt dem Zeiger, Abriss per Ziehen, Klick oder Enter ---------- */
  function ticket(tk) {
    if (tk.dataset.obwReady) return; tk.dataset.obwReady = '1';
    var main = tk.querySelector('.obw-tk__main'), stub = tk.querySelector('.obw-tk__stub'), key = 'obw-tk-torn';
    try { if (localStorage.getItem(key) === '1') tk.classList.add('is-torn'); } catch (e) {}
    main.addEventListener('pointermove', function (e) {
      var r = main.getBoundingClientRect();
      main.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      main.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
    function tear() {
      if (tk.classList.contains('is-torn')) return;
      stub.style.transform = ''; tk.classList.add('is-torn');
      try { localStorage.setItem(key, '1'); } catch (e) {}
      try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}
    }
    var x0 = null, dx = 0;
    stub.addEventListener('pointerdown', function (e) { if (tk.classList.contains('is-torn')) return; x0 = e.clientX; dx = 0; stub.setPointerCapture(e.pointerId); stub.style.transition = 'none'; });
    stub.addEventListener('pointermove', function (e) {
      if (x0 === null) return; dx = Math.max(0, e.clientX - x0);
      var rb = dx > 90 ? 90 + (dx - 90) * .35 : dx; /* weicher Widerstand */
      stub.style.transform = 'translateX(' + rb + 'px) rotate(' + (rb / 14) + 'deg)';
    });
    function end() {
      if (x0 === null) return; x0 = null; stub.style.transition = '';
      if (dx > 60 || dx < 4) tear(); else stub.style.transform = '';
    }
    stub.addEventListener('pointerup', end); stub.addEventListener('pointercancel', function () { x0 = null; stub.style.transition = ''; stub.style.transform = ''; });
    stub.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tear(); } });
  }

  /* ---------- Pixel-Button: Canvas-Pixel in Markenfarben, Aufdecken ab Zeiger, Klick-Welle ---------- */
  var PX_COLS = ['#00AFAA', '#5FD6D0', '#DDF4F1', '#FFFFFF', '#078B7E'];
  function pixelButton(btn) {
    if (btn.dataset.obwPxReady) return; btn.dataset.obwPxReady = '1';
    var cv = document.createElement('canvas'); cv.setAttribute('aria-hidden', 'true'); btn.insertBefore(cv, btn.firstChild);
    var ctx = cv.getContext('2d'); if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, px = [], S = 3, G = 6;
    var ox = 0, oy = 0, r = 0, rT = 0, ripple = null, raf = 0, visible = true, t0 = 0;
    function build() {
      var b = btn.getBoundingClientRect(); W = b.width; H = b.height; if (!W) return;
      cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); px = [];
      for (var y = G / 2; y < H; y += G) for (var x = G / 2; x < W; x += G)
        px.push({ x: x, y: y, c: PX_COLS[(Math.random() * PX_COLS.length) | 0], p: Math.random() * 6.28, s: .6 + Math.random() * 1.4 });
      ox = W / 2; oy = H / 2; draw(performance.now());
    }
    function draw(t) {
      ctx.clearRect(0, 0, W, H);
      var maxR = Math.hypot(W, H), amb = reduce ? 0 : 1;
      for (var i = 0; i < px.length; i++) {
        var p = px[i], d = Math.hypot(p.x - ox, p.y - oy), a = 0;
        if (d < r) a = (1 - d / Math.max(r, 1)) * .9 + .1;
        if (amb) a = Math.max(a, .07 + .07 * Math.sin(t / 900 * p.s + p.p));
        if (ripple) { var rr = (t - ripple.t) / 1.6, w = Math.abs(Math.hypot(p.x - ripple.x, p.y - ripple.y) - rr); if (w < 10) a = Math.max(a, 1 - w / 10); }
        if (a <= .02) continue;
        a *= .55 + .45 * Math.sin(t / 260 * p.s + p.p) * (reduce ? 0 : 1) + (reduce ? .45 : 0);
        ctx.globalAlpha = Math.max(0, Math.min(1, a)); ctx.fillStyle = p.c; ctx.fillRect(p.x - S / 2, p.y - S / 2, S, S);
      }
      ctx.globalAlpha = 1;
      if (ripple && (t - ripple.t) / 1.6 > maxR) ripple = null;
    }
    function loop(t) {
      r += (rT - r) * .12;
      draw(t);
      var busy = Math.abs(rT - r) > .5 || ripple || (!reduce && visible);
      raf = busy ? requestAnimationFrame(loop) : 0;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(loop); }
    function at(e) { var b = btn.getBoundingClientRect(); ox = e.clientX - b.left; oy = e.clientY - b.top; }
    btn.addEventListener('pointerenter', function (e) { at(e); rT = Math.hypot(W, H) * .75; kick(); });
    btn.addEventListener('pointermove', function (e) { at(e); kick(); });
    btn.addEventListener('pointerleave', function () { rT = 0; kick(); });
    btn.addEventListener('focus', function () { ox = W / 2; oy = H / 2; rT = Math.hypot(W, H) * .6; kick(); });
    btn.addEventListener('blur', function () { rT = 0; kick(); });
    btn.addEventListener('pointerdown', function (e) { at(e); if (!reduce) { ripple = { x: ox, y: oy, t: performance.now() }; kick(); } });
    if ('ResizeObserver' in window) new ResizeObserver(build).observe(btn); else build();
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) kick(); }).observe(btn);
    build(); kick();
  }

  /* ---------- Kalender (.ics) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-obw-ics]'); if (!a) return;
    e.preventDefault();
    var start = a.getAttribute('data-start'), title = a.getAttribute('data-title') || 'odaban® Black Deals Early Access', url = a.getAttribute('data-url') || location.href;
    var d = new Date(start); if (isNaN(d)) return;
    function f(x) { return x.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//odaban//Black Deals//DE', 'BEGIN:VEVENT', 'UID:' + Date.now() + '@odaban.de',
      'DTSTAMP:' + f(new Date()), 'DTSTART:' + f(d), 'DTEND:' + f(new Date(d.getTime() + 36e5)), 'SUMMARY:' + title, 'DESCRIPTION:Dein Code kommt per E-Mail. ' + url, 'URL:' + url, 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    var blob = new Blob([ics], { type: 'text/calendar' }), href = URL.createObjectURL(blob), l = document.createElement('a');
    l.href = href; l.download = 'odaban-black-deals.ics'; document.body.appendChild(l); l.click(); l.remove(); setTimeout(function () { URL.revokeObjectURL(href); }, 2000);
  });

  /* ---------- Sanftes Scrollen zum Formular ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#anmelden"]'); if (!a) return;
    var t = document.getElementById('anmelden'); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    var inp = t.querySelector('input[type=email]'); if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, reduce ? 0 : 500);
  });

  /* ---------- Einblenden ---------- */
  function reveal() {
    var els = document.querySelectorAll('[data-obw-reveal]'); if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (x) { x.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (x) { io.observe(x); });
  }

  function neon(el) {
    if (el._obwNeon) return; el._obwNeon = 1;
    var words = (el.getAttribute('data-obw-neon') || '').split('|').filter(function (w) { return w.trim(); });
    var w = el.querySelector('.obw-neon__w'); if (!w || words.length < 2) return;
    function fit() { el.style.width = ''; var m = 0, cur = w.textContent; words.forEach(function (x) { w.textContent = x; m = Math.max(m, w.offsetWidth); }); w.textContent = cur; el.style.width = Math.ceil(m + 2) + 'px'; }
    fit(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit); window.addEventListener('resize', fit);
    var ms = Math.max(1800, parseInt(el.getAttribute('data-interval'), 10) || 2600), i = 0, timer, visible = true;
    var sr = document.createElement('span'); sr.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap'; sr.textContent = words.join(', '); el.appendChild(sr); w.setAttribute('aria-hidden', 'true');
    function next() {
      if (!visible || document.hidden) return;
      i = (i + 1) % words.length;
      if (reduce) { w.textContent = words[i]; return; }
      el.classList.remove('is-on'); el.classList.add('is-off');
      setTimeout(function () { w.textContent = words[i]; el.classList.remove('is-off'); void el.offsetWidth; el.classList.add('is-on'); }, 340);
    }
    timer = setInterval(next, ms + (reduce ? 0 : 340));
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(el);
  }

  /* ---------- Holo-Badge: Folie dreht beim Scrollen und folgt dem Zeiger ---------- */
  function holo(el) {
    if (el._obwHolo || reduce) return; el._obwHolo = 1;
    var raf = 0, px = .5, py = .3;
    function paint() {
      raf = 0; var y = window.scrollY || 0;
      el.style.setProperty('--h', (y * .35 + px * 90).toFixed(1) + 'deg');
      el.style.setProperty('--hx', (20 + ((y * .08) % 60) + px * 20).toFixed(1) + '%');
      el.style.setProperty('--hy', (15 + py * 50).toFixed(1) + '%');
    }
    function req() { if (!raf) raf = requestAnimationFrame(paint); }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('pointermove', function (e) { px = e.clientX / innerWidth; py = e.clientY / innerHeight; req(); }, { passive: true });
    window.addEventListener('deviceorientation', function (e) { if (e.gamma == null) return; px = Math.min(1, Math.max(0, (e.gamma + 45) / 90)); py = Math.min(1, Math.max(0, (e.beta - 10) / 70)); req(); }, { passive: true });
    paint();
  }
  function shine() { document.querySelectorAll('.obw-week,.obw-step,.obw-offer').forEach(function (c) { if (!c.querySelector('.obw-shine')) { var s = document.createElement('span'); s.className = 'obw-shine'; s.setAttribute('aria-hidden', 'true'); c.insertBefore(s, c.firstChild); } }); }

  /* ---------- Sale: Code-Sperre bis zum Datum, ?code= aus der Mail, Code in den Warenkorb ---------- */
  function gate(g) {
    if (g._obw) return; g._obw = 1;
    var until = Date.parse(g.getAttribute('data-until') || ''), key = 'obw-ea-code';
    var codes = (g.getAttribute('data-codes') || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
    if (!isNaN(until) && Date.now() >= until) return;           /* nach Ablauf: Seite offen */
    if (window.Shopify && Shopify.designMode) return;           /* im Theme-Editor nicht sperren */
    var form = g.querySelector('form'), inp = g.querySelector('input'), err = g.querySelector('.obw-gate__err');
    function ok(c) { return c && codes.indexOf(c.toUpperCase()) > -1; }
    function unlock(c, anim) {
      try { localStorage.setItem(key, c.toUpperCase()); } catch (e) {}
      if (g.getAttribute('data-apply') === 'true') { try { fetch('/discount/' + encodeURIComponent(c.toUpperCase()) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {}); } catch (e) {} }
      function done() { g.hidden = true; document.documentElement.classList.remove('obw-locked'); }
      if (anim && !reduce) { g.classList.add('is-open-anim'); setTimeout(done, 420); } else done();
      try { window.dataLayer = window.dataLayer || []; dataLayer.push({ event: 'black_deals_unlock' }); } catch (e) {}
    }
    var fromUrl = param('code'), saved = ''; try { saved = localStorage.getItem(key) || ''; } catch (e) {}
    if (ok(fromUrl)) { unlock(fromUrl, false); return; }
    if (ok(saved)) { unlock(saved, false); return; }
    g.hidden = false; document.documentElement.classList.add('obw-locked'); setTimeout(function () { inp.focus(); }, 200);
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var v = (inp.value || '').trim();
      if (ok(v)) { err.classList.remove('is-on'); unlock(v, true); return; }
      err.textContent = g.getAttribute('data-err') || 'Dieser Code passt nicht.'; err.classList.add('is-on');
      g.classList.remove('is-wrong'); void g.offsetWidth; g.classList.add('is-wrong'); inp.select();
    });
    if (!isNaN(until)) setTimeout(function () { g.hidden = true; document.documentElement.classList.remove('obw-locked'); }, Math.min(until - Date.now(), 2147483000));
  }
  /* ---------- Sale: Angebote zeitgesteuert (ab/bis) ---------- */
  function offerTimes() {
    var now = Date.now();
    document.querySelectorAll('.obw-offer[data-from],.obw-offer[data-until]').forEach(function (o) {
      var f = Date.parse(o.getAttribute('data-from') || ''), u = Date.parse(o.getAttribute('data-until') || '');
      o.classList.toggle('is-soon', !isNaN(f) && now < f);
      if (!isNaN(u) && now >= u) o.style.display = 'none';
    });
  }

  function init() {
    document.querySelectorAll('.obw-hero[data-start]').forEach(countdown);
    document.querySelectorAll('form[data-obw-signup]').forEach(signup);
    document.querySelectorAll('[data-obw-tk]').forEach(ticket);
    document.querySelectorAll('[data-obw-px]').forEach(pixelButton);
    document.querySelectorAll('[data-obw-neon]').forEach(neon);
    document.querySelectorAll('[data-obw-holo]').forEach(holo);
    shine();
    document.querySelectorAll('[data-obw-gate]').forEach(gate);
    offerTimes();
    reveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
